<mat-tab-group>
  <mat-tab label="API Key Requests">
    <div class="tab-content">
<!--      <h2>Pending API Key Requests</h2>-->
      <p>Review pending user requests. Requests are approved individually.</p>

      <tgrid-api-key-requests-table
        [rows]="requestRows()"
        [loading]="loading()"
        [errorMessage]="errorMessage()"
        [approvingRequestIds]="approvingRequestIds()"
        (approveRequest)="approveRequest($event)"
        (denyRequest)="openDenyDialog($event)">
      </tgrid-api-key-requests-table>
    </div>
  </mat-tab>

  <mat-tab label="API Key Status">
    <div class="tab-content">
      <p>Search and review all API key records, including active keys, expired keys, and denied requests.</p>

      <tgrid-api-key-status-table
        [rows]="statusRows()"
        [loading]="statusLoading()"
        [errorMessage]="statusErrorMessage()">
      </tgrid-api-key-status-table>
    </div>
  </mat-tab>
</mat-tab-group>
